import { ToasterElement } from 'ofe-common/components';
import Formatters from '../globals/Formatters';
import StateManager from '../globals/StateManager';
import Validators from './Validators';
import Analytics from './Analytics';

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		/**
		 * Szerokość ekranu, gdzie:
		 * * 1: >= 600px,
		 * * 2: >= 992px,
		 * * 3: > 1280px
		 * * 4: > 1680px
		 * */
		ScreenSize: number;
		/**
		 * Obiekt zawierający informacje o aktualnej szerokości ekranu:
		 * * isXs: >= 480px,
		 * * isSm: >= 600px,
		 * * isMd: >= 768px,
		 * * isLg: >= 992px,
		 * * isXl: >= 1024px
		 *  */
		Screen: {
			isXs: boolean;
			isSm: boolean;
			isMd: boolean;
			isLg: boolean;
			isXl: boolean;
		};
		/** Zawiera metody ułatwiające nawigację używając klasy {@link StateManager}. */
		State: StateManager;
		/** Zawiera metody ułatwiające formatowanie wartości na łańcuchy znaków używając klasy {@link Formatters}. */
		Format: Formatters;
		/** Zawiera metody walidujące wejście formularzy używając klasy {@link Validators}. */
		Validate: Validators;
		/** Zawiera globalny stan aplikacji */
		CurrentState: any;
		/** Komponent do wyświetlania powiadomień w rogu ekranu. */
		Toast: InstanceType<typeof ToasterElement>;
		/** Zawiera metody służące do wysyłania analityki. */
		Analytics: typeof Analytics;
		toggleBusyState(isBusy: boolean): void;
	}
}

const appMixin = {
	computed: {
		Analytics() {
			return window.Analytics;
		},
		CurrentModule() {
			return this.$root.$data.Module;
		},
		ModuleComponent() {
			return this.$root.$refs.CurrentModule;
		},
		ControllerComponent() {
			return this.$root.$refs.CurrentModule.$refs.CurrentController;
		},
		State() {
			return this.$root.$data.StateManager;
		},
		CurrentState() {
			return (this.State && this.State.CurrentState) ? this.State.CurrentState.state : {};
		},
		Format() {
			return this.$root.$data.Formatters;
		},
		Validate() {
			return this.$root.$data.Validators;
		},
		ScreenSize() {
			const width = this.$root.$data.WindowWidth;
			if (width > 1680) { return 4; }
			if (width > 1280) { return 3; }
			if (width > 991) { return 2; }
			if (width > 599) { return 1; }
			return 0;
		},
		Screen() {
			const width = this.$root.$data.WindowWidth as number;

			return {
				isXs: width >= 480,
				isSm: width >= 600,
				isMd: width >= 768,
				isLg: width >= 992,
				isXl: width >= 1024,
			};
		},
		Toast() {
			return this.$root.$refs.Toaster;
		},
	},
	provide() {
		return {
			toast: this.Toast,
			screenSize: () => this.ScreenSize,
			stateManager: this.State,
		};
	},
	methods: {
		toggleBusyState(isBusy: boolean) {
			if (isBusy === undefined) { isBusy = !this.$root.$data.IsSaving; }
			this.$root.$data.IsSaving = isBusy;
		},
	},
};

export default appMixin;
